import { Box, Tabs, Tab, CircularProgress } from "@mui/material";
import isEmpty from "lodash/isEmpty";
import React, { FC, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import DeclineEventModal from "../../components/pages-components/decline-event-modal/DeclineEventModal";
import JoinWhatsAppGroupModal from "../../components/pages-components/join-whatsApp-group-modal/JoinWhatsAppGroupModal";
import Footer from "../../components/pages-components/details-tab-content/Footer";
import ReOpenModal from "../../components/pages-components/re-open-modal/ReOpenModal";
import {
	ACCEPT_REQUEST,
	CHAT_TAB_VALUE,
	DECLINE_EVENT,
	DECLINE_REQUEST,
	EVENT_CONCLUDED,
	EventDetailTabsEnum,
	QUOTE_TAB_VALUE,
	REOPEN,
	REOPEN_TITLE,
	REQUEST_ACCEPT_DECLINE_TITLE,
	REQUEST_ACCEPT_DECLINE_TITLE_CULINARY,
	SEND_FIRST_TIME_QUOTE,
	SEND_QUOTE,
	SHOW_INTEREST,
	SHOW_INTEREST_TITLE,
	VENDOR_STATUS_FOR_HIDE_DECLINE_EVENT,
} from "../../constants/eventDetail";
import { useOnUpdateEvent } from "../../hooks/firestoreHooks/eventUpdated";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { resetApiErrorEvent } from "../../store/events/eventSlice";
import { useApiToast } from "../../hooks/useApiToast";
import {
	acceptEventRequestThunk,
	declineEventRequestThunk,
	getEventBidThunk,
	getEventDetailThunk,
	getEventValuesCMSThunk,
	getVendorEventGroupRecord,
	getWhatsAppGroupLink,
	respondToEventFilterThunk,
} from "../../store/events/eventThunk";
import { resetApiError } from "../../store/user/userSlice";
import { REDUX_REQUEST_STATUS } from "../../types/commonTypes";
import { BUTTON_COLOR, BUTTON_VARIANT } from "../../types/coreButtonTypes";
import {
	EventRequestStatusEnum,
	EventStatusEnum,
	IEventDetailMessages,
	IWhatsAppGroupInfo,
	RESPOND_TO_EVENT_TYPES,
	VendorEventResponseStatusesEnum,
	WhatsAppGroupStatusEnum,
	iEventBids,
	iEventType,
	iRespondEventPayload,
	iType,
} from "../../types/eventTypes";
import { whatsAppModalVariations } from "../../utils/content";
import { useOnUpdateQuotes } from "../../hooks/firestoreHooks/qoutesUpdated";
import { ROUTE_PATHS, ROUTE_QUERY_CONSTANTS } from "../../routes";
import { formatDate, getStringsFirstLetter, isObjectEmpty } from "../../utils/commonUtils";
import { MessagingContainer } from "../../components/pages-components/b2c-event-details-layouts/messaging";
import ShopifyDeclineModal from "../../components/reusable-components/modals/shopify-decline-modal/ShopifyDeclineModal";
import {
	breadCrumbTitleAndLinkEventDetail,
	getB2CEventDeclineReason,
	getFromCms,
	isB2CEventDeclined,
	scrollToSectionHelper,
} from "../../helpers/common";
import { getPrepaidMenuDisplayText, getPrepaidMenuSelectionPackages } from "../../helpers/prepaidMenuHelpers";
import PrepaidMenuSelections from "../../components/pages-components/prepaid-menu-selections/PrepaidMenuSelections";
import { useVisibilityChange } from "../../hooks/useVisibilityChange";
import { unwrapResult } from "@reduxjs/toolkit";
import { REMOVE_SPECIAL_CHAR_FROM_STRING } from "../../utils/regex";
import { EnumUserCurrentTab } from "../../constants/enums";
import { DECLINE_VENDOR_REASONS } from "../../constants/formConstants";
import CompleteMenuModal from "../../components/pages-components/complete-menu-modal/CompleteMenuModal";
import ContactSupportModal from "../../components/pages-components/contact-support-modal/ContactSupportModal";
import InnerPageMobileHeader from "../../components/reusable-components/inner-page-mobile-header/InnerPageMobileHeader";
import IsMobile from "../../hooks/isMobile";
import NoData from "../../components/reusable-components/no-data/NoData";
import useCheckScroll from "../../hooks/useCheckScroll";
import ContentHeader from "../../components/reusable-components/dashboard-contents/content-header/ContentHeader";
import CollapsibleCard from "../../components/pages-components/b2c-event-details-layouts/collapsible-card/CollapsibleCard";
import B2CEventTabContent from "../../components/pages-components/b2c-event-details-layouts/b2c-event-tab-content/B2CEventTabContent";
import QuotesTabContentB2C from "../../components/pages-components/b2c-event-details-layouts/tabs/QuotesTabContentB2C";
import SendbirdChatContinerB2C from "../../components/pages-components/b2c-event-details-layouts/messaging/SendbirdChatContinerB2C/SendbirdChatContinerB2C";
import OrderSummaryCard from "../../components/pages-components/b2c-event-details-layouts/order-summary-card/OrderSummaryCardB2C";
import EventDetailsSection from "../../components/pages-components/b2c-event-details-layouts/EventDetailsSection";
import DeclineReasonBanner from "../../components/pages-components/b2b/event-details/decline-reason-banner/DeclineReasonBanner";
import SendbirdEventMentionSync from "../../components/SendBird/SendbirdEventMentionSync";
import { applyMentionFlagsToRows } from "../../utils/sendbird/chatAccessibility";
import "./eventDetail.scss";

interface iEventDetailProps {
	getInnerPagePath: string | boolean;
}
const TOP_SPACING_THRESHOLD = 100;

const EventDetail: FC<iEventDetailProps> = ({ getInnerPagePath }) => {
	const navigate = useNavigate();
	const isMobile = IsMobile();
	const params = useParams();
	const dispatch = useAppDispatch();
	const { userDetails, userCurrentTab } = useAppSelector((state) => state.user) || {};
	const eventDetail = useAppSelector((state) => state.events.event) || {};
	const eventBid = useAppSelector((state) => state.events.bids);
	const isLoading = useAppSelector((state) => state.events.isLoading);
	const { apiError } = useAppSelector((state) => state.events);
	const { apiSuccess } = useAppSelector((state) => state.events);
	const cms = useAppSelector((state) => state.events.cms);
	const [bids, setBids] = useState<iEventBids>({} as iEventBids);
	const [actionStatus, setActionStatus] = useState<number>(-1);
	const [ReOpenModalState, setReOpenModalState] = useState(false);
	const [declineEventModalState, setDeclineEventModalState] = useState(false);
	const [declineReason, setDeclineReason] = useState("");
	const [otherDeclineReason, setOtherDeclineReason] = useState("");
	const location = useLocation();
	const [ContactSupportModalState, setContactSupportModalState] = useState(false);
	const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);
	const [trigger, setTrigger] = useState(false);
	const [isChatVisible, setIsChatVisible] = useState(false);
	const [isScrolling, setIsScrolling] = useState(false);
	const [whatsAppBannerVisible, setWhatsappBannerVisible] = useState<boolean>(true);
	const [searchParams, setSearchParams] = useSearchParams(location.search);

	const oldActiveTab = searchParams.get("tab") as EventDetailTabsEnum;
	const [activeTab, setActiveTab] = useState(oldActiveTab || EventDetailTabsEnum.Details);
	const selectedType = searchParams.get("type") || "";

	const [shouldStartUpdatingEvent, setShouldStartUpdatingEvent] = useState(false);
	const [shouldStartUpdatingEventQuotes, setShouldStartUpdatingEventQuotes] = useState(false);
	const [shopifyDeclineModalState, setShopifyDeclineModalState] = useState(false);
	const [mentionFlagsByUrl, setMentionFlagsByUrl] = useState<Record<string, boolean>>({});

	// State for controlling collapsible cards expansion on mobile
	const [eventCardExpanded, setEventCardExpanded] = useState<boolean>(true);
	const [quotesCardExpanded, setQuotesCardExpanded] = useState<boolean>(true);

	const [whatsAppGroupDetails, setWhatsAppGroupDetails] = useState<IWhatsAppGroupInfo>(
		{} as IWhatsAppGroupInfo,
	);

	const isRequest = !!eventDetail?.request;
	const menuOpen = !!searchParams.get("menu");
	const [CompleteMenuModalState, setCompleteMenuModalState] = useState(menuOpen);
	const vendorEventRecord = eventDetail.vendorEventRecord;
	const menuDisplayText = useMemo(
		() => getPrepaidMenuDisplayText(eventDetail?.request),
		[eventDetail?.request],
	);
	const menuSelectionPackages = useMemo(
		() => getPrepaidMenuSelectionPackages(eventDetail?.request),
		[eventDetail?.request],
	);

	// Refs for scroll detection
	const messagingRef = useRef<HTMLDivElement>(null);
	const eventRef = useRef<HTMLDivElement>(null);
	const quotesRef = useRef<HTMLDivElement>(null);
	const tabsRef = useRef<HTMLDivElement>(null);
	const pageLayoutRef = useRef<HTMLElement>(null);
	const expanded = useCheckScroll(
		pageLayoutRef as React.RefObject<HTMLElement>,
		TOP_SPACING_THRESHOLD,
		trigger,
	);

	const isFocused = useVisibilityChange();
	const selectedChat: IEventDetailMessages = eventDetail?.messages?.[0] as IEventDetailMessages;
	const rawMessages = eventDetail?.messages ?? [];
	const messagesWithMentionFlags = useMemo(
		() => applyMentionFlagsToRows(rawMessages, mentionFlagsByUrl),
		[rawMessages, mentionFlagsByUrl],
	);
	const selectedChatWithMentions = messagesWithMentionFlags[0] ?? selectedChat;
	const shouldShowChat = !isMobile || isChatVisible;

	const handleMentionFlagsUpdate = useCallback((flags: Record<string, boolean>) => {
		setMentionFlagsByUrl((previous) => {
			let changed = false;
			const next = { ...previous };
			for (const [url, hasMention] of Object.entries(flags)) {
				if (previous[url] !== hasMention) {
					next[url] = hasMention;
					changed = true;
				}
			}
			return changed ? next : previous;
		});
	}, []);

	useEffect(() => {
		if (eventDetail?.id) setTrigger(true);
	}, [eventDetail?.id]);

	const [loadedEventId, setLoadedEventId] = useState<string | null>(null);

	const fetchEventDetails = useCallback(async () => {
		if (!!params?.id) {
			await dispatch(getEventDetailThunk({ id: params?.id }));
			setLoadedEventId(params.id);
			setShouldStartUpdatingEvent(true);
		}
	}, [params?.id]);

	const fetchEventBids = useCallback(async () => {
		if (params.id) {
			await dispatch(getEventBidThunk({ id: params?.id }));
			setShouldStartUpdatingEventQuotes(true);
		}
	}, [params.id]);

	const handleGoBack = () => {
		if (window.history.length > 1) {
			navigate(-1);
		} else {
			navigate(ROUTE_PATHS.AI_DIRECT_REQUEST);
		}
	};

	useOnUpdateEvent(shouldStartUpdatingEvent, fetchEventDetails, params?.id || "");
	useOnUpdateQuotes(shouldStartUpdatingEventQuotes, fetchEventBids, params.id || "");

	useEffect(() => {
		fetchEventDetails();
		fetchEventBids();
		dispatch(getEventValuesCMSThunk({}));
	}, [fetchEventDetails, fetchEventBids]);

	// Intersection Observer for scroll detection
	useEffect(() => {
		if (!isMobile) return;

		const thresholds = Array.from({ length: 21 }, (_, i) => i / 20); // 0..1 in steps of .05

		const observer = new IntersectionObserver(
			(entries) => {
				if (isScrolling) return;

				let mostVisibleId: EventDetailTabsEnum | null = null;
				let maxRatio = 0;

				entries.forEach((entry) => {
					const sectionId = entry.target.getAttribute("data-section") as EventDetailTabsEnum;
					if (!sectionId) return;

					if (entry.intersectionRatio > maxRatio) {
						maxRatio = entry.intersectionRatio;
						mostVisibleId = sectionId;
					}
				});

				if (mostVisibleId && mostVisibleId !== activeTab) {
					setActiveTab(mostVisibleId);
				}
			},
			{
				root: null,
				rootMargin: "0px 0px -30% 0px",
				threshold: thresholds,
			},
		);

		const sections = [
			{ ref: messagingRef, id: EventDetailTabsEnum.Chat },
			{ ref: eventRef, id: EventDetailTabsEnum.Details },
			{ ref: quotesRef, id: EventDetailTabsEnum.MyQuote },
		];

		sections.forEach(({ ref, id }) => {
			if (ref.current) {
				ref.current.setAttribute("data-section", id);
				observer.observe(ref.current);
			}
		});

		return () => {
			observer.disconnect();
		};
	}, [isMobile, activeTab, isScrolling, eventDetail]);

	useEffect(() => {
		if (selectedChat?.channelUrl && !isMobile) {
			handleChatClick();
		}
	}, [selectedChat?.channelUrl, isMobile]);

	const handleChatClick = async () => {
		if (selectedChat) {
			if (selectedChat.channelUrl) {
				setMentionFlagsByUrl((previous) => ({ ...previous, [selectedChat.channelUrl]: false }));
			}
			isMobile && handleTabChange(EventDetailTabsEnum.Chat);
			setIsChatVisible(true);

			const vendorEventId = selectedChat.vendorEventId;
			const details = await dispatch(getVendorEventGroupRecord({ vendorEventId }));
			if (details.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
				const unwrappedResult = unwrapResult(details);
				setWhatsAppGroupDetails(unwrappedResult);
			} else {
				setWhatsAppGroupDetails({} as IWhatsAppGroupInfo);
			}
		}
	};

	useEffect(() => {
		if (eventBid) {
			setBids({ ...eventBid });
		}
	}, [eventBid]);

	const onToasterClose = useCallback(() => {
		dispatch(resetApiErrorEvent());
		dispatch(resetApiError());
	}, [dispatch]);

	// Handle API error and success toast notifications
	useApiToast({
		apiError,
		apiSuccess,
		onClose: onToasterClose,
	});

	useEffect(() => {
		const tab = searchParams.get("tab") as EventDetailTabsEnum;
		if (tab) {
			// Validate tab value against available tabs for current view
			const validTabs = isMobile
				? [EventDetailTabsEnum.Chat, EventDetailTabsEnum.Details, EventDetailTabsEnum.MyQuote]
				: [EventDetailTabsEnum.Details, EventDetailTabsEnum.MyQuote];

			if (validTabs.includes(tab)) {
				handleTabChange(tab);
			} else {
				// If tab is not valid for current view, set to default
				const defaultTab = EventDetailTabsEnum.Details;
				handleTabChange(defaultTab);
			}
		}
	}, [location.search, isMobile]);

	const getGroupDetails = async (vendorEventId: string) => {
		const details = await dispatch(
			getVendorEventGroupRecord({
				vendorEventId: vendorEventId,
			}),
		);
		if (details.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
			const unwrappedResult = unwrapResult(details);
			setWhatsAppGroupDetails(unwrappedResult);
		}
	};

	const isUserPrivacyEnabled = useMemo(() => {
		if (whatsAppGroupDetails && userDetails?.whatsappNumbersList?.length) {
			const userWhatsappNumbersList = userDetails?.whatsappNumbersList.map((whatsappNumber) =>
				whatsappNumber.replace(REMOVE_SPECIAL_CHAR_FROM_STRING, ""),
			);
			return !whatsAppGroupDetails?.participants?.some((item) => userWhatsappNumbersList.includes(item.id));
		} else return true;
	}, [whatsAppGroupDetails, userDetails?.whatsappNumber]);

	useEffect(() => {
		if (isFocused && vendorEventRecord?.isWhatsappGroupCreated) getGroupDetails(vendorEventRecord.id);
	}, [isFocused, vendorEventRecord]);

	const handleTabChange = (newValue: EventDetailTabsEnum) => {
		setActiveTab(newValue);

		// On mobile, expand the corresponding card if it's collapsed
		if (isMobile) {
			if (newValue === EventDetailTabsEnum.Details && !eventCardExpanded) {
				setEventCardExpanded(true);
			} else if (newValue === EventDetailTabsEnum.MyQuote && !quotesCardExpanded) {
				setQuotesCardExpanded(true);
			}
		}

		setSearchParams(
			(prev) => {
				prev.set("tab", newValue);
				return prev;
			},
			{ replace: true },
		);

		scrollToSection(newValue);
	};

	const scrollToSection = (section: EventDetailTabsEnum) => {
		setIsScrolling(true);
		scrollToSectionHelper(`eventDetailsTag_${section}`);

		setTimeout(() => {
			setIsScrolling(false);
		}, 1000);
	};

	const updateSearchParams = (selectedType: string, activeTab: EventDetailTabsEnum) => {
		setSearchParams(
			(prev) => {
				prev.set("type", selectedType || ROUTE_QUERY_CONSTANTS.PrePaidRequests);
				activeTab && prev.set("tab", activeTab);
				return prev;
			},
			{ replace: true },
		);
	};

	useEffect(() => {
		if (
			isRequest &&
			[EventRequestStatusEnum.Active, EventRequestStatusEnum.OnHold].includes(
				eventDetail?.request?.status || 0,
			)
		) {
			updateSearchParams(selectedType || ROUTE_QUERY_CONSTANTS.PrePaidRequests, activeTab);
		} else if (eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Invited) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.DirectRequests, activeTab);
		} else if (eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.AiDirectRequest, activeTab);
		} else if (eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Bidding) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.InProgress, activeTab);
		} else if (eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Completed) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.Completed, activeTab);
		} else if (
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Accepted ||
			eventDetail?.request?.status === EventRequestStatusEnum.Accepted
		) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.Approved, activeTab);
		} else if (
			!isRequest &&
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AvailableForBidding
		) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.EventDirectory, activeTab);
		} else if (
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Rejected ||
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.RejectedByCustomer ||
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Cancelled ||
			[
				EventRequestStatusEnum.Cancelled,
				EventRequestStatusEnum.Reject,
				EventRequestStatusEnum.Expired,
			].includes(eventDetail?.request?.status || 0)
		) {
			updateSearchParams(ROUTE_QUERY_CONSTANTS.Declined, activeTab);
		}
	}, [eventDetail, isRequest]);

	const closeChatHandler = () => {
		return eventModalHandler(RESPOND_TO_EVENT_TYPES.DECLINE);
	};

	const showWhatsAppIconAndBanner = useMemo(() => {
		if (
			vendorEventRecord?.isWhatsappGroupCreated &&
			whatsAppGroupDetails.groupStatus === WhatsAppGroupStatusEnum?.active
		) {
			return true;
		}
		return false;
	}, [vendorEventRecord?.isWhatsappGroupCreated, whatsAppGroupDetails]);

	const eventModalHandler = async (status: number) => {
		if (status === RESPOND_TO_EVENT_TYPES.ACCEPT) {
			await eventActionHandler(status);
			navigate(`${location.pathname}?tab=${CHAT_TAB_VALUE}`);
		} else if (status === RESPOND_TO_EVENT_TYPES.DECLINE) {
			setActionStatus(status);
			setDeclineEventModalState(true);
		}
	};

	const handleShowNewQuoteForm = () => {
		navigate(`${ROUTE_PATHS.QUOTE_FORM}?eventId=${params?.id}`);
	};

	const eventModalHandlerForAIrequest = () => {
		navigate(`${location.pathname}?tab=${QUOTE_TAB_VALUE}`, {
			replace: true,
		});
		handleShowNewQuoteForm();
	};

	const eventModalHandlerRequest = async (status: number) => {
		if (status === RESPOND_TO_EVENT_TYPES.ACCEPT) {
			eventDetail?.request && (await dispatch(acceptEventRequestThunk(eventDetail.request.id)));
		} else if (status === RESPOND_TO_EVENT_TYPES.DECLINE) {
			setShopifyDeclineModalState(true);
		}
	};

	const eventModalHandlerReOpen = (status: number) => {
		setActionStatus(status);
		setReOpenModalState(true);
	};

	const eventActionHandler = async (status: number, firstVendorInteraction?: boolean) => {
		if (params?.id) {
			const payload = {
				id: params?.id,
				status: status,
				declineReason: {
					value: otherDeclineReason
						? ""
						: DECLINE_VENDOR_REASONS.find((reason) => reason.FormControlLabelValue === declineReason)
							?.FormControlLabelLabel || "",
				} as iType,
				otherDeclineReason: otherDeclineReason,
				firstVendorInteraction,
			} as iRespondEventPayload;

			const resp = await dispatch(respondToEventFilterThunk(payload));

			if (resp.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
				const eventDetailResp = await dispatch(getEventDetailThunk({ id: params?.id }));
				if (eventDetailResp.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
					const eventDetail = eventDetailResp.payload as iEventType;
					setDeclineReason("");
					setOtherDeclineReason("");
					setDeclineEventModalState(false);
					setReOpenModalState(false);

					setTimeout(() => {
						if (
							(eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AvailableForBidding ||
								eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Invited ||
								eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin ||
								eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Bidding) &&
							status === RESPOND_TO_EVENT_TYPES.ACCEPT
						) {
							navigate(
								{
									pathname: `/event-detail/${params?.id}`,
									search: `?tab=${activeTab || EventDetailTabsEnum.Details}&type=${ROUTE_QUERY_CONSTANTS.InProgress}`,
								},
								{ replace: true },
							);
						} else if (
							eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Rejected ||
							eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Cancelled
						) {
							navigate(
								{
									pathname: `/event-detail/${params?.id}`,
									search: `?tab=${activeTab || EventDetailTabsEnum.Details}&type=declined`,
								},
								{ replace: true },
							);
						}
					}, 300);
				}
			}
		}
	};

	const showAction = () => {
		const activeEventStatus = [
			VendorEventResponseStatusesEnum.AssignedByAdmin,
			VendorEventResponseStatusesEnum.AvailableForBidding,
			VendorEventResponseStatusesEnum.Bidding,
		];
		const showDeclineButton = !isMobile;
		if (isRequest && eventDetail?.request?.status === EventRequestStatusEnum.Active) {
			return (
				<Footer
					secondBtnStatus={RESPOND_TO_EVENT_TYPES.ACCEPT}
					secondBtntitle={ACCEPT_REQUEST}
					firstBtnStatus={RESPOND_TO_EVENT_TYPES.DECLINE}
					firstBtntitle={DECLINE_REQUEST}
					title={REQUEST_ACCEPT_DECLINE_TITLE_CULINARY}
					btnhandler={eventModalHandlerRequest}
					declineButtonRed
					footerRequestClass={`${isMobile ? "accept_request_footer" : ""}`}
					acceptRequest={isMobile && true}
					customerServiceModalOpner={() => setContactSupportModalState(true)}
					expireAt={
						eventDetail?.request?.status === EventRequestStatusEnum.Active
							? eventDetail?.request?.expireAt || ""
							: ""
					}
					eventRequestId={""}
				/>
			);
		} else if (!isRequest && eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Invited) {
			return (
				<Footer
					secondBtnStatus={RESPOND_TO_EVENT_TYPES.ACCEPT}
					secondBtntitle={ACCEPT_REQUEST}
					firstBtnStatus={RESPOND_TO_EVENT_TYPES.DECLINE}
					firstBtntitle={DECLINE_REQUEST}
					title={REQUEST_ACCEPT_DECLINE_TITLE}
					btnhandler={eventModalHandler}
					declineButtonRed
					footerRequestClass={`${isMobile ? "accept_request_footer" : ""}`}
					acceptRequest={isMobile && true}
					customerServiceModalOpner={() => setContactSupportModalState(true)}
				/>
			);
		} else if (
			!isRequest &&
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin &&
			isObjectEmpty(bids.currentBid)
		) {
			return (
				<Footer
					firstBtnStatus={showDeclineButton ? RESPOND_TO_EVENT_TYPES.DECLINE : undefined}
					firstBtntitle={showDeclineButton ? DECLINE_EVENT : undefined}
					secondBtnStatus={RESPOND_TO_EVENT_TYPES.ACCEPT}
					secondBtntitle={SEND_QUOTE}
					title={SEND_FIRST_TIME_QUOTE}
					firstBtnHandler={eventModalHandler}
					btnhandler={eventModalHandlerForAIrequest}
					vendorStatus={eventDetail?.vendorStatus}
					declineButtonRed
					footerRequestClass="send_quote_footer"
				/>
			);
		} else if (
			!isRequest &&
			eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AvailableForBidding
		) {
			return (
				<Footer
					firstBtnStatus={showDeclineButton ? RESPOND_TO_EVENT_TYPES.DECLINE : undefined}
					firstBtntitle={showDeclineButton ? DECLINE_EVENT : undefined}
					secondBtnStatus={1}
					secondBtntitle={SHOW_INTEREST}
					title={SHOW_INTEREST_TITLE}
					btnhandler={eventModalHandler}
					declineButtonRed
					footerRequestClass="show_interest_footer"
				/>
			);
		} else if (!isRequest && eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Rejected) {
			return (
				<Footer
					firstBtnStatus={-1}
					firstBtntitle={""}
					secondBtnStatus={1}
					secondBtntitle={REOPEN}
					title={REOPEN_TITLE}
					btnhandler={eventModalHandlerReOpen}
					customerServiceModalOpner={() => setContactSupportModalState(true)}
					footerRequestClass="reopen_footer"
				/>
			);
		} else if (!isRequest && eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.Completed) {
			return (
				<Footer
					title={EVENT_CONCLUDED}
					btnhandler={eventActionHandler}
					customerServiceModalOpner={() => setContactSupportModalState(true)}
					acceptRequest={false}
				/>
			);
		} else if (!isRequest && activeEventStatus.includes(eventDetail?.vendorStatus) && !isMobile) {
			return (
				<Footer
					firstBtnStatus={RESPOND_TO_EVENT_TYPES.DECLINE}
					firstBtntitle={DECLINE_EVENT}
					secondBtntitle={SEND_QUOTE}
					title={""}
					btnhandler={() => handleShowNewQuoteForm()}
					firstBtnHandler={() => eventModalHandler(RESPOND_TO_EVENT_TYPES.DECLINE)}
					vendorStatus={eventDetail?.vendorStatus}
					declineButtonV2
					fullWidth
					footerRequestClass={"dashboardFooter__declineButtonFooter"}
					acceptRequest={false}
				/>
			);
		} else if (!isRequest && activeEventStatus.includes(eventDetail?.vendorStatus) && isMobile) {
			return (
				<Footer
					firstBtntitle={SEND_QUOTE}
					secondBtnStatus={-1}
					secondBtntitle={""}
					title={""}
					btnhandler={() => {
						handleShowNewQuoteForm();
					}}
					vendorStatus={eventDetail?.vendorStatus}
					sendQuoteButton
					acceptRequest={false}
					fullWidth={true}
				/>
			);
		} else return null;
	};

	const RadioGroupHandleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDeclineReason((event.target as HTMLInputElement).value);
	};

	const otherOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		setOtherDeclineReason(event.target.value);
	};

	const onPressJoinWhatsApp = async () => {
		if (!vendorEventRecord) {
			window.open(whatsAppGroupDetails.invitationLink, "_blank");
			return;
		}

		if (!isUserPrivacyEnabled) {
			await navigator.clipboard.writeText(whatsAppGroupDetails.name);
		}

		const result = await dispatch(getWhatsAppGroupLink({ vendorEventId: vendorEventRecord?.id }));

		if (result.meta.requestStatus === REDUX_REQUEST_STATUS.FULFILLED) {
			const unwrappedResult = unwrapResult(result);
			const groupLink = unwrappedResult?.data.invitationLink || "";
			window.open(groupLink, "_blank");
		} else {
			window.open(whatsAppGroupDetails.invitationLink, "_blank");
		}
	};

	const handleCloseChatClick = () => {
		setIsChatVisible(false);
		setShowWhatsAppModal(false);
		handleTabChange(EventDetailTabsEnum.Details);
	};

	const showWhatsAppIcon = useMemo(() => {
		return (
			selectedChat?.isWhatsappGroupCreated &&
			whatsAppGroupDetails?.groupStatus === WhatsAppGroupStatusEnum?.active
		);
	}, [selectedChat?.isWhatsappGroupCreated, whatsAppGroupDetails?.groupStatus]);

	const renderTabContent = () => {
		// Render all content in a single scroll view
		return (
			<Box className="tabContentContainer">
				{/* Messaging Section */}
				<Box id={`eventDetailsTag_${EventDetailTabsEnum.Chat}`} ref={messagingRef}>
					{renderMessagingSection()}
				</Box>

				{/* Event Section */}
				<Box id={`eventDetailsTag_${EventDetailTabsEnum.Details}`} ref={eventRef}>
					<CollapsibleCard
						headerTitle="Event Details"
						isExpanded={eventCardExpanded}
						onToggle={setEventCardExpanded}
					>
						<B2CEventTabContent
							eventDetail={eventDetail as iEventType}
							selectedType={selectedType}
							cms={cms}
							request={eventDetail?.request || undefined}
						/>
					</CollapsibleCard>
				</Box>

				{/* Quotes Section */}
				<Box id={`eventDetailsTag_${EventDetailTabsEnum.MyQuote}`} ref={quotesRef}>
					<CollapsibleCard
						headerTitle="Quotes"
						isExpanded={quotesCardExpanded}
						onToggle={setQuotesCardExpanded}
					>
						<QuotesTabContentB2C
							eventDetail={eventDetail as iEventType}
							cms={cms}
							onClickAddAdditionalQuote={handleShowNewQuoteForm}
							isEventDeclined={isB2CEventDeclined(eventDetail)}
						/>
					</CollapsibleCard>
				</Box>
			</Box>
		);
	};

	const renderMessagingSection = () => {
		return (
			<>
				{!(shouldShowChat && selectedChat?.channelUrl) ? (
					<SendbirdEventMentionSync
						rows={rawMessages.map((message) => ({
							channelUrl: message.channelUrl,
							isNewModelChannel: message.isNewModelChannel,
						}))}
						vendorSendBirdId={eventDetail?.vendorSendBirdId}
						onFlagsUpdate={handleMentionFlagsUpdate}
					/>
				) : null}
				{shouldShowChat && selectedChat?.channelUrl ? (
					<SendbirdChatContinerB2C
						selectedChat={selectedChatWithMentions}
						vendorSendBirdId={eventDetail?.vendorSendBirdId}
						showWhatsAppIcon={showWhatsAppIcon}
						showWhatsAppBanner={showWhatsAppIcon && whatsAppBannerVisible}
						setWhatsAppModalOpen={setShowWhatsAppModal}
						handleCloseChatClick={handleCloseChatClick}
						setWhatsappBannerVisible={(value: boolean) => setWhatsappBannerVisible(value)}
						expanded={expanded}
						setDeclineEventModalState={setDeclineEventModalState}
						eventDetail={eventDetail}
						handleSendbirdMessageUpdates={fetchEventDetails}
						showChatHeaderBackButton={false}
						isMobile={isMobile}
						onSendChat={() => {
							eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin &&
								eventActionHandler(RESPOND_TO_EVENT_TYPES.ACCEPT);
						}}
					/>
				) : (
					<MessagingContainer
						chat={selectedChatWithMentions}
						onChatClick={handleChatClick}
						expanded={expanded}
						eventDetail={eventDetail}
					/>
				)}
			</>
		);
	};

	const renderPageContent = () => (
		<>
			<Helmet>
				<title>{`Event Detail | ${getFromCms(eventDetail?.serviceCategory?.value, cms)}`}</title>
			</Helmet>

			<Box
				className="content"
				ref={pageLayoutRef}
				sx={{
					display: "flex",
					flexDirection: "column"
				}}>
				<Box className="pageLayoutEventDetail" sx={{
					flex: "1"
				}}>
					{!isMobile && (
						<ContentHeader
							contentHeaderTitle={"Event summary"}
							breadCrumbsLinkTitle={breadCrumbTitleAndLinkEventDetail(eventDetail, selectedType)?.title || ""}
							breadCrumbsHref={breadCrumbTitleAndLinkEventDetail(eventDetail, selectedType)?.link || ""}
							breadCrumbsCurrentTitle={eventDetail?.name}
							ordNumber={Number(eventDetail?.orderNumber || 0)}
							createdBy={
								isRequest
									? `${eventDetail?.request?.customerName}`
									: `${eventDetail?.customer?.firstName} ${eventDetail?.customer?.lastName || ""}`
							}
						/>
					)}
					<Box className="eventDetailsContainer">
						{isMobile ? (
							<Box className="orderSummaryAndMobileTabsContainer">
								<OrderSummaryCard
									createdBy={
										isRequest
											? `${eventDetail?.request?.customerName}`
											: `${eventDetail?.customer?.firstName} ${eventDetail?.customer?.lastName || ""}`
									}
									ordNumber={Number(eventDetail?.orderNumber || 0)}
								/>

								{isB2CEventDeclined(eventDetail as iEventType) && (
									<DeclineReasonBanner
										declineReason={getB2CEventDeclineReason(eventDetail as iEventType) || ""}
									/>
								)}

								{/* Mobile Tabs Navigation */}
								<Box className="mobileTabsContainer" ref={tabsRef}>
									<Tabs
										value={activeTab}
										onChange={(_, newValue) => handleTabChange(newValue)}
										variant="fullWidth"
									>
										<Tab label="Messaging" value={EventDetailTabsEnum.Chat} />
										<Tab label="Event" value={EventDetailTabsEnum.Details} />
										<Tab label="Quotes" value={EventDetailTabsEnum.MyQuote} />
									</Tabs>

									{renderTabContent()}
								</Box>
							</Box>
						) : (
							<>
								{renderMessagingSection()}
								<EventDetailsSection
									onHold={eventDetail?.request?.status === EventRequestStatusEnum.OnHold}
									cms={cms}
									selectedType={selectedType}
									selectedTab={activeTab}
									eventDetail={eventDetail as iEventType}
									setSelectedTab={(value: EventDetailTabsEnum) => handleTabChange(value)}
									onClickAddAdditionalQuote={handleShowNewQuoteForm}
									isEventDeclined={isB2CEventDeclined(eventDetail)}
									expireAt={
										eventDetail?.request?.status === EventRequestStatusEnum.Active
											? eventDetail?.request?.expireAt || ""
											: ""
									}
									OnClickTriggerLeftContainerScroll={() => setTrigger(true)}
								/>
							</>
						)}
					</Box>
				</Box>
			</Box>
		</>
	);

	const hasChannelUrl = Boolean(eventDetail?.channelUrl);
	const isActiveEventWithExpiredRequest =
		eventDetail?.status === EventStatusEnum.Active &&
		eventDetail?.request?.status === EventRequestStatusEnum.Expired;

	const shouldShowLoader = isLoading || (!!params?.id && loadedEventId !== params.id);

	if (shouldShowLoader) {
		return (
			<Box className="eventDetailLoaderContainer">
				<CircularProgress size={24} />
			</Box>
		);
	}

	return (
		<>
			{isMobile && shouldShowChat && selectedChat?.channelUrl ? (
				<SendbirdChatContinerB2C
					className="eventChatContainerMobileView"
					selectedChat={selectedChatWithMentions}
					vendorSendBirdId={eventDetail?.vendorSendBirdId}
					showWhatsAppIcon={showWhatsAppIcon}
					showWhatsAppBanner={showWhatsAppIcon && whatsAppBannerVisible}
					setWhatsAppModalOpen={setShowWhatsAppModal}
					handleCloseChatClick={handleCloseChatClick}
					setWhatsappBannerVisible={(value: boolean) => setWhatsappBannerVisible(value)}
					handleSendbirdMessageUpdates={fetchEventDetails}
					eventDetail={eventDetail}
					setDeclineEventModalState={setDeclineEventModalState}
					expanded={expanded}
					showChatHeaderBackButton={true}
					isMobile={true}
					onSendChat={() => {
						eventDetail?.vendorStatus === VendorEventResponseStatusesEnum.AssignedByAdmin &&
							eventActionHandler(RESPOND_TO_EVENT_TYPES.ACCEPT);
					}}
				/>
			) : (
				<>
					{isMobile && (
						<InnerPageMobileHeader
							goBackOnClick={handleGoBack}
							customerFirstLastName={
								isRequest && eventDetail.request
									? getStringsFirstLetter(
										eventDetail.request?.customerName.split(" ")[0],
										eventDetail.request?.customerName.split(" ")[1],
									)
									: getStringsFirstLetter(eventDetail.customer?.firstName, eventDetail.customer?.lastName)
							}
							eventName={isRequest ? eventDetail.request?.name || "" : eventDetail?.name}
							eventDate={formatDate(eventDetail.eventDate)}
							customerName={
								isRequest
									? eventDetail.request?.customerName || ""
									: `${eventDetail.customer?.firstName} ${eventDetail.customer?.lastName}`
							}
							declineEvent={
								VENDOR_STATUS_FOR_HIDE_DECLINE_EVENT.includes(eventDetail?.vendorStatus) ||
									eventDetail?.status === 4
									? ""
									: DECLINE_EVENT
							}
							declineEventOnclick={
								isRequest && eventDetail?.request?.status === EventRequestStatusEnum.Active
									? () => eventModalHandlerRequest(RESPOND_TO_EVENT_TYPES.DECLINE)
									: () => closeChatHandler()
							}
							customerCID={eventDetail?.allowDirectCall ? eventDetail.customerTwilioCID : ""}
							isCustomerPhoneNumberExist={Boolean(eventDetail?.customer?.phoneNumber)}
							handleShowWhatsAppModal={() => {
								setShowWhatsAppModal(true);
							}}
							isWhatsappGroupCreated={showWhatsAppIconAndBanner && userCurrentTab === EnumUserCurrentTab.Chat}
						/>
					)}
					{!isEmpty(eventDetail) ? renderPageContent() : <NoData sx={{ bgcolor: "#f2f2f2" }} />}
					<div className="footer footerEventDetails">{showAction()}</div>
				</>
			)}
			<ReOpenModal
				modalHeaderText="Do you want to re-open this event?"
				open={ReOpenModalState}
				onClose={() => setReOpenModalState(false)}
				reOpenBodyText="Re-opening the event will re-enable chats and quotes,
				and move the event to the in progress section"
				buttonText="Confirm"
				variant={BUTTON_VARIANT.CONTAINED}
				color={BUTTON_COLOR.PRIMARY}
				fullWidth={true}
				coreBtnPill={true}
				onclick={() => eventActionHandler(actionStatus)}
			/>
			<DeclineEventModal
				modalHeaderText="Decline Event?"
				open={declineEventModalState}
				onClose={() => setDeclineEventModalState(false)}
				declineModalBodyTitle="Please specify a reason in order to decline the event"
				buttonText="Confirm"
				variant={BUTTON_VARIANT.CONTAINED}
				color={BUTTON_COLOR.PRIMARY}
				fullWidth={true}
				coreBtnPill={true}
				disabled={!declineReason}
				onclick={() => eventActionHandler(actionStatus)}
				RadioGroupValue={declineReason}
				RadioGroupHandleChange={RadioGroupHandleChange}
				radioLabels={DECLINE_VENDOR_REASONS}
				otherOnChange={otherOnChange}
				otherPlaceholder="Input a reason other than ones specified"
			/>
			{isRequest && !!menuDisplayText && (
				<CompleteMenuModal
					open={CompleteMenuModalState}
					onClose={() => setCompleteMenuModalState(false)}
					menu={
						menuSelectionPackages?.length ? (
							<PrepaidMenuSelections packages={menuSelectionPackages} />
						) : (
							menuDisplayText
						)
					}
				/>
			)}
			<ContactSupportModal
				open={ContactSupportModalState}
				onClose={() => setContactSupportModalState(false)}
			/>

			<ShopifyDeclineModal
				modalHeaderText="Are you sure you want to Decline?"
				open={shopifyDeclineModalState}
				onClose={() => {
					setShopifyDeclineModalState(false);
				}}
				shopifyDeclineModalBodyText="Are you sure you want to decline this event? This action can not be undone"
				declineOnClick={async () => {
					eventDetail?.request && (await dispatch(declineEventRequestThunk(eventDetail.request.id)));
					setShopifyDeclineModalState(false);
				}}
				backOnClick={() => {
					setShopifyDeclineModalState(false);
				}}
			/>

			<JoinWhatsAppGroupModal
				buttonText={
					isUserPrivacyEnabled
						? whatsAppModalVariations.joinGroup
						: whatsAppModalVariations.copyGroupNameBTNText
				}
				heading={whatsAppModalVariations.chatOnWhatsApp}
				subheading={whatsAppModalVariations.aGroupCalled}
				middleText={whatsAppGroupDetails?.name ?? ""}
				endingText={
					isUserPrivacyEnabled
						? whatsAppModalVariations.privacyEnabled.replace(
							"{codeBlock}",
							"<span style='font-weight:500;'>privacy settings</span>",
						)
						: whatsAppModalVariations.copyGroupNameText
				}
				closeModal={() => setShowWhatsAppModal(false)}
				openWhatsAppModal={showWhatsAppModal}
				disclaimer={!isUserPrivacyEnabled ? whatsAppModalVariations.ifYouHaveMoreThenOne : ""}
				onClickJoinWhatsApp={() => {
					onPressJoinWhatsApp();
				}}
			/>
		</>
	);
};

export default EventDetail;
